module.exports = __webpack_public_path__ + "media/images/national-archives_logo-d127d99c3b781704caf44adb0dc7ff09.png";